import "../core/Polyfills";
import Selection from "../../../../../../core-lib/js/Selection/Selection";
import Animations from "../library/Animations";
import Scroll from "../library/Scroll";
import Cookies from "../library/Cookies";
import BackgroundImage from "../library/BackgroundImage";
import Browsers from "./Browsers";
import Station from "./Station";
import Menus from "./Menus";
import SearchForm from "./SearchForm";
import BackToTop from "./BackToTop";
// import Comments from "./Comments";
import Hero from "./Hero";
import Swimlane from "./Swimlane";
import Categories from "./Categories";
import Videos from "./Videos";
import AdSlot from "./AdSlot";
import Showtimes from "./Showtimes";
// import ComingUp from "./ComingUp";
import TicketForm from "./TicketForm";
import Tickets from "./Tickets";
import BeOnTheShow from "./BeOnTheShow";
import Giveaways from "./Giveaways";
import StayConnected from './StayConnected';
// import YouTubeEmbeds from "./YouTubeEmbeds";
// import SliderGallery from "./SliderGallery";
// import Trivia from "./Trivia";
// import TriviaBadges from "./TriviaBadges";
// import BSDForm from "./BSDForm";
import { CookieConsent } from "./CookieConsent";
import { BrightcoveCustomMacros } from "./BrightcoveCustomMacros";
// import { Countdown } from "./Countdown";
import Carousel from "./Carousel";
import VideoCategoryHeader from "./VideoCategoryHeader";
import PostDetail from "./PostDetail";
import YouTube from "./YouTube";

const bowser = require("bowser");
vb.innerWidth = window.innerWidth;
vb.browser = bowser.getParser(window.navigator.userAgent);
vb.header = document.querySelector(".header");
vb.headerContainer = document.querySelector(".header__container");
// vb.headerPrimaryMenu = document.querySelector(".header-menu--primary");
// vb.headerPrimaryMenuItems = document.querySelectorAll(
// 	".header-menu__item--primary"
// );

// vb.headerSearch = document.querySelector(".header__search");
// vb.headerSearchInput = document.querySelector(".header__search-input");
// vb.headerSearchButton = document.querySelector(".header__search-button");
vb.headerBurger = document.getElementById("menu__toggle");
vb.animations = new Animations("animation", "animated");
vb.scroll = new Scroll();
vb.cookies = new Cookies();
vb.usingTouchscreen = false;
vb.itemsLoadedEvent = new CustomEvent("itemsloaded");

document.addEventListener("touchstart", (e) => {
	vb.usingTouchscreen = true;
});

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

new Browsers();
new Selection(".img2bg").each((el) => BackgroundImage(el), false);
new Menus();
new Station();
new SearchForm(urlParams);
new BackToTop();
const youTubeModule = new YouTube();

// new Selection('.comments').each(el => new Comments(el), false);
new Selection(".swimlane").each((el) => new Swimlane(el), false);
new Selection(".hero").each((el) => new Hero(el, youTubeModule), false);
new Selection(".categories").each((el) => new Categories(el), false);
new Selection(".videos-grid").each((el) => new Videos(el), false);
new Selection(".ad-slot").each((el) => new AdSlot(el), false);
new Selection(".showtimes").each((el) => new Showtimes(el), false);
// new Selection('.coming-up').each(el => new ComingUp(el), false);
new Selection(".ticket-form").each((el) => new TicketForm(el), false);
new Selection(".tickets").each((el) => new Tickets(el), false);
new Selection(".upcoming-shows").each((el) => new BeOnTheShow(el), false);
new Selection(".giveaways").each((el) => new Giveaways(el), false);
new Selection(".stay-connected").each((el) => new StayConnected(el), false);
// new Selection('iframe[src*="youtube"]').each(el => new YouTubeEmbeds(el), false);
// new Selection('.slider-gallery').each(el => new SliderGallery(el), false);
// new Selection('.trivia').each(el => new Trivia(el), false);
// new Selection('.countdown').each(el => new Countdown(el), false);
// new TriviaBadges();
// new Selection('.form--bsd').each(el => new BSDForm(el), false);
new Selection(".hero--alt").each((el) => new Carousel(el), false);
new Selection(".video-category-header").each(
	(el) => new VideoCategoryHeader(el),
	false
);
new PostDetail();
CookieConsent.maybeShow();

if (window.googletag) {
	window.googletag.cmd.push(() => {
		window.googletag.pubads().enableSingleRequest();
		window.googletag.companionAds().setRefreshUnfilledSlots(true);
		window.googletag.pubads().enableVideoAds();
		window.googletag.pubads().addEventListener("slotRenderEnded", (e) => {
			const w = new Selection(window);
			w.trigger("adsloaded", e.slot.getSlotElementId());
			w.trigger("resize");
		});

		console.log('==================== window.enableGptTest: ' , window.enableGptTest);
		
		if (window.enableGptTest) {
			let testParameter = null;

			if (urlParams.has('test')) {
				testParameter = urlParams.get('test');
			}
			
			if (testParameter) {
				window.googletag.pubads().setTargeting("test", testParameter);

				console.log('====================== DID SET GPT TEST PARAMETER #1 ======================', testParameter);
			}
		} else if (urlParams.has('test')) {
			window.googletag.pubads().setTargeting("test", urlParams.get('test'));
		}
		
		window.googletag.enableServices();
		new Selection(".ad-slot__ad--generated").each((el) => {
			window.googletag.display(el.id);

			// if (el.dataset.videoCompanion == '0' || vb.cookies.get('vb_paused') == '1') {
			// 	window.googletag.pubads().refresh([vb.gSlots[el.id]]);
			// }
		}, false);
	});
}

window.addEventListener("resize", (e) => (vb.innerWidth = window.innerWidth));
window.addEventListener("load", (e) => {
	setTimeout(() => {
		const w = new Selection(window);
		w.trigger("resize");
	}, 1000);
});
